import { render } from "./ViewNewSimulation.vue?vue&type=template&id=32bc1916&scoped=true&ts=true"
import script from "./ViewNewSimulation.vue?vue&type=script&lang=ts"
export * from "./ViewNewSimulation.vue?vue&type=script&lang=ts"

import "./ViewNewSimulation.vue?vue&type=style&index=0&id=32bc1916&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bc1916"]])

export default __exports__